import Cookies from 'js-cookie'
import { UserInfo } from '@/store/modules/user/state'

export interface PortalState{
    isMobile: boolean;
    portalToken: string
    portalCurrentPageId: number
    portalInfo: UserInfo
    portalLoading: boolean
    // 门户标题
    portalTitle: string
}
export const state: PortalState = {
  isMobile: false,
  portalToken: Cookies.get('portal-token') || '',
  portalCurrentPageId: -1,
  portalInfo: {
    account: "",
    avatar: "",
    email: "",
    notify1: " ",
    notify2: " ",
    status: 1,
    stno: "",
    username: "",
    usertype: " ",
  },
  portalLoading: false,
  portalTitle: '',
}
